export const CardMacroMode = Object.freeze({
  VIEW: "view",
  EDIT: "edit",
});
